import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as postActions from 'modules/post/post.actions';
import PostComponent from 'modules/post/web/post.component';
import { View, Title, Button } from 'modules/styled';

class Flagged extends Component {
  static propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    flagged: PropTypes.array,
    metaPosts: PropTypes.object,
    posts: PropTypes.object,
  };

  componentDidMount() {
    this.props.actions.getFlaggedPosts();
  }

  render() {
    const { flagged, posts, auth, actions } = this.props;

    const postsEl = flagged.map((p) => {
      const post = posts.posts[p];
      const parentPost = post.parentPost ? posts.posts[post.parentPost] : null;
      const link = posts.links[post.metaPost];
      const authorizedToDelete =
        post.user === auth.user._id || auth.user.role === 'admin';

      return (
        <View key={post._id}>
          <PostComponent
            key={post._id}
            {...this.props}
            flagged={post.flagged}
            post={parentPost || post}
            comment={parentPost ? post : null}
            link={link}
          >
            {authorizedToDelete && (
              <View>
                <Button
                  sx={{ bg: 'red', width: 13, m: 4 }}
                  onPress={() => actions.deletePost(post)}
                >
                  Delete
                </Button>
              </View>
            )}
          </PostComponent>
        </View>
      );
    });

    return (
      <View>
        <Title sx={{ mx: 4 }}>Flagged Posts</Title>
        {postsEl}
      </View>
    );
  }
}

export default connect(
  (state) => ({
    auth: state.auth,
    flagged: state.posts.flagged,
    posts: state.posts,
    all: state.posts,
  }),
  (dispatch) => ({
    actions: bindActionCreators(postActions, dispatch),
  })
)(Flagged);
